import React from 'react';
import PropTypes from 'prop-types';

import { ExternalLinkProvider } from '../../context/ExternalLink';

import Footer from './Footer';

const FooterContainer = ({ locales, localeToggle, ...restProps }) => (
  <ExternalLinkProvider
    currentLocale={locales.current}
    localeToggle={localeToggle}
  >
    <Footer locales={locales} {...restProps} />
  </ExternalLinkProvider>
);

FooterContainer.propTypes = {
  locales: PropTypes.shape({
    current: PropTypes.string
  }).isRequired,
  localeToggle: PropTypes.shape({
    chinese: PropTypes.bool
  })
};

FooterContainer.defaultProps = {
  localeToggle: {}
};

export default FooterContainer;
